import Molkky from '@/assets/graphical-elements/molkky.svg'
import {cn} from '@/lib/utils'
import {type IconProps} from '../types'

export const MolkkyIcon = ({className}: IconProps) => <Molkky className={cn('fill-current', className)} />
